import { collectionNames } from '../../collection/collectionNames'

interface Props {
  workspaceId: string
}

export const getTaskFileStoragePathV2 = ({ workspaceId }: Props): string => {
  return `${collectionNames.workspaces}/${workspaceId}/${collectionNames.tasks}/`
}
